import './Tag.scss';

import * as React from 'react';

import { css } from '../../util/Css';

export interface TagProps {
  text: string;
  tooltip?: string;
  className?: string;
}

export class Tag extends React.Component<TagProps> {
  public render(): JSX.Element {
    return (
      <div className={css('tag-container', this.props.className)} title={this.props.tooltip}>
        {this.props.text}
      </div>
    );
  }
}
